import React, { useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from '../../../hooks/useThemeColor';

const InlinePageSizeSelector = ({ defaultValue, onChange, className }) => {
  const pageSizeOptions = [
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  
  // Get theme color
  const themeColor = useThemeColor();

  // Local state to track the selected page size
  const [selectedPageSize, setSelectedPageSize] = useState(defaultValue);

  // Update local state when defaultValue changes
  useEffect(() => {
    setSelectedPageSize(defaultValue);
  }, [defaultValue]);

  const handlePageSizeChange = (value) => {
    const newPageSize = { value, label: value };
    setSelectedPageSize(newPageSize);
    if (onChange) {
      onChange(newPageSize);
    }
  };

  const buttonStyle = {
    padding: '6px 12px',
    margin: '0 2px',
    border: isDarkMode ? '1px solid #404040' : '1px solid #e9ecef',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    minWidth: '40px',
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    overflow: 'hidden',
  };

  const activeButtonStyle = {
    ...buttonStyle,
    backgroundColor: themeColor,
    color: '#ffffff',
    borderColor: themeColor,
    boxShadow: `0 2px 6px ${themeColor}40`,
  };

  const inactiveButtonStyle = {
    ...buttonStyle,
    backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
    color: isDarkMode ? '#ffffff' : '#495057',
    borderColor: isDarkMode ? '#404040' : '#e9ecef',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  }

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center' }}>
      {pageSizeOptions.map((option) => {
        const isSelected = selectedPageSize && selectedPageSize.value === option.value;
        return (
          <button
            key={option.value}
            onClick={() => handlePageSizeChange(option.value)}
            style={isSelected ? activeButtonStyle : inactiveButtonStyle}
            onMouseEnter={(e) => {
              if (!isSelected) {
                e.target.style.backgroundColor = isDarkMode ? '#404040' : '#f8f9fa';
                e.target.style.borderColor = isDarkMode ? '#ffffff' : '#232B2B';
                e.target.style.boxShadow = isDarkMode ? '0 2px 6px rgba(255, 255, 255, 0.1)' : '0 2px 6px rgba(35, 43, 43, 0.2)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                e.target.style.backgroundColor = isDarkMode ? '#2d3436' : '#ffffff';
                e.target.style.borderColor = isDarkMode ? '#404040' : '#e9ecef';
                e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
              }
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default InlinePageSizeSelector;
